import { el, clear, formatarNome, limpavel } from '../lib/dom.js';
import { sessao, sair } from '../lib/auth.js';
import { ir, onNavegar, caminhoAtual } from '../lib/router.js';
import { operadorAtual, definirOperador, definirOperadorLogin, operandoComoOutro, verificarPin, redefinirMeuPin } from '../lib/operador.js';
import { abrirTrocaOperador } from './operadorSwitch.js';
import { abrirModal } from './modal.js';
import { toast } from '../lib/toast.js';
import { supabase } from '../config/supabaseClient.js';
import { contarSugestoesPendentes, contarSugestoesSetor, criarSugestaoSistema, feedbacksDecisao } from '../domain/sugestoes.js';
import { mostrarFeedbacksRecusa } from './feedbackRecusa.js';
import { contarMotivosPendentes, contarEmpresasPendentes } from '../domain/visitaListas.js';
import { APP_VERSION } from '../config/version.js';
import { podeAcessar, ehGestorAtivo, rotaInicial } from '../lib/permissoes.js';
import { limparAssinaturas } from '../lib/realtime.js';
import { abrirSugerirNovaChave } from './sugerirChave.js';
import { appLauncher } from './appLauncher.js';

const ITENS = [
  { sep: 'Acessos' },
  { caminho: '/movimentacao', rotulo: 'Chaves', icone: 'ph-key', secao: 'chaves' },
  { caminho: '/cracha', rotulo: 'Crachá', icone: 'ph-identification-badge', secao: 'cracha' },
  { caminho: '/visita-administrativa', rotulo: 'Visita administrativa', icone: 'ph-user-square', secao: 'visita_adm' },
  { rotulo: 'Visita assistencial', icone: 'ph-stethoscope', desativado: true, secao: 'visita_assist' },
  { sep: 'Gestão' },
  { caminho: '/dashboard', rotulo: 'KPIs', icone: 'ph-gauge', secao: 'kpis' },
  { caminho: '/pesquisa', rotulo: 'Pesquisa / Histórico', icone: 'ph-magnifying-glass', secao: 'pesquisa' },
  { caminho: '/relatorios', rotulo: 'Relatórios', icone: 'ph-file-text', gestorSo: true },
  { sep: 'Cadastros' },
  { caminho: '/chaves', rotulo: 'Chaves', icone: 'ph-key', secao: 'cad_chaves' },
  { caminho: '/colaboradores', rotulo: 'Colaboradores', icone: 'ph-users', secao: 'cad_colaboradores' },
  { caminho: '/empregadores', rotulo: 'Empregadores', icone: 'ph-building', secao: 'cad_empregadores' },
  { caminho: '/setores', rotulo: 'Setores', icone: 'ph-tree-structure', secao: 'cad_setores' },
  { caminho: '/usuarios', rotulo: 'Usuários', icone: 'ph-user-gear', gestorSo: true },
  { sep: 'Visitas' },
  { caminho: '/visita-motivos', rotulo: 'Motivos', icone: 'ph-clipboard-text', secao: 'cad_visita_motivo' },
  { caminho: '/visita-empresas', rotulo: 'Empresas/órgãos', icone: 'ph-building', secao: 'cad_visita_empresa' },
];

let montado = false;
let avisosCanal = null, avisosTimer = null, avisosDeb = null;

export function montarLayout() {
  if (montado) return;
  const app = document.getElementById('app');
  clear(app);

  async function fazerLogout() { definirOperador(null); await sair(); location.hash = '#/login'; }

  const navBox = el('div', { class: 'sidebar__nav' });
  const sidebar = el('aside', { class: 'sidebar' }, [
    el('div', { class: 'sidebar__brand' }, [el('img', { class: 'sidebar__logo', src: '/logo_nome.png', alt: 'AcessaHUOL' })]),
    navBox,
    el('div', { class: 'sidebar__rodape', id: 'rodapeNav' }),
  ]);

  function visivel(item) {
    if (item.gestorSo) return ehGestorAtivo();
    if (item.secao) return podeAcessar(item.secao);
    return true;
  }

  function montarNav() {
    clear(navBox);
    let sepPend = null;
    for (const item of ITENS) {
      if (item.sep) { sepPend = item.sep; continue; }
      if (sepPend) { navBox.append(el('div', { class: 'sidebar__sep', text: sepPend })); sepPend = null; }
      if (item.desativado) {
        navBox.append(el('div', { class: 'navlink navlink--bloq', title: 'Em desenvolvimento (em breve)', onClick: () => toast('Módulo em desenvolvimento.', 'info') },
          [el('i', { class: `ph ${item.icone}` }), el('span', { text: item.rotulo }), el('i', { class: 'ph ph-clock navlink__cadeado' })]));
        continue;
      }
      if (!visivel(item)) {
        navBox.append(el('div', { class: 'navlink navlink--bloq', title: 'Sem acesso pelo seu perfil', onClick: () => toast('Você não tem acesso a este módulo pelo seu perfil.', 'info') },
          [el('i', { class: `ph ${item.icone}` }), el('span', { text: item.rotulo }), el('i', { class: 'ph ph-lock navlink__cadeado' })]));
        continue;
      }
      navBox.append(el('div', { class: 'navlink', dataset: { caminho: item.caminho }, onClick: () => ir(item.caminho) },
        [el('i', { class: `ph ${item.icone}` }), el('span', { text: item.rotulo })]));
    }
    // rodapé: Configurações só GESTOR
    const rod = sidebar.querySelector('#rodapeNav');
    clear(rod);
    if (ehGestorAtivo()) {
      rod.append(el('div', { class: 'navlink', dataset: { caminho: '/configuracoes' }, onClick: () => ir('/configuracoes') },
        [el('i', { class: 'ph ph-gear' }), el('span', { text: 'Configurações' })]));
    } else {
      rod.append(el('div', { class: 'navlink navlink--bloq', title: 'Sem acesso pelo seu perfil', onClick: () => toast('Você não tem acesso a Configurações pelo seu perfil.', 'info') },
        [el('i', { class: 'ph ph-gear' }), el('span', { text: 'Configurações' }), el('i', { class: 'ph ph-lock navlink__cadeado' })]));
    }
    marcarAtivo(caminhoAtual());
    atualizarAvisos();
  }

  // ----- Operador (chip + menu) -----
  const chipMenu = el('div', { class: 'conta-menu', style: 'display:none' });
  function fecharChipMenu() { chipMenu.style.display = 'none'; document.removeEventListener('click', aoForaChip); }
  function aoForaChip(e) { if (!chipWrap.contains(e.target)) fecharChipMenu(); }
  function pintarChipMenu() {
    clear(chipMenu);
    chipMenu.append(
      el('div', { class: 'conta-menu__op-atual' }, [el('i', { class: 'ph ph-clock-user' }), el('span', { text: operadorAtual.nome || 'Você' })]),
      el('div', { class: 'conta-menu__sep' }),
      el('button', { class: 'conta-menu__item', onClick: () => { fecharChipMenu(); abrirTrocaOperador(atualizarOperador); } },
        [el('i', { class: 'ph ph-arrows-left-right' }), el('span', { text: 'Trocar de operador' })]),
    );
    if (operandoComoOutro()) {
      chipMenu.append(el('button', { class: 'conta-menu__item', onClick: () => { fecharChipMenu(); voltarAoLogin(); } },
        [el('i', { class: 'ph ph-lock-open' }), el('span', { text: 'Voltar a ser eu' })]));
    }
  }
  const chipOp = el('div', { class: 'topbar__op', title: 'Operador' });
  function pintarChip() {
    clear(chipOp);
    chipOp.classList.toggle('topbar__op--restrito', operandoComoOutro());
    chipOp.append(
      el('i', { class: 'ph ph-clock-user' }),
      el('span', { text: `Operador: ${operadorAtual.nome || 'Você'}` }),
      el('i', { class: 'ph ph-caret-down', style: 'font-size:11px;opacity:.7' }),
    );
  }
  const chipWrap = el('div', { class: 'topbar__op-wrap' }, [chipOp, chipMenu]);
  chipOp.addEventListener('click', (e) => {
    e.stopPropagation(); fecharMenuConta();
    if (chipMenu.style.display === 'none') { pintarChipMenu(); chipMenu.style.display = ''; document.addEventListener('click', aoForaChip); }
    else fecharChipMenu();
  });

  // ----- Conta conectada (login): avatar + menu -----
  const email = sessao.authUser?.email ?? '';
  const inicial = (email[0] || '?').toUpperCase();
  const perfil = sessao.usuario?.perfil ?? '';
  const menuConta = el('div', { class: 'conta-menu', style: 'display:none' }, [
    el('div', { class: 'conta-menu__rotulo', text: 'Conta conectada (login)' }),
    el('div', { class: 'conta-menu__email', text: email, title: email }),
    el('div', { class: 'conta-menu__perfil', text: perfil }),
    el('div', { class: 'conta-menu__sep' }),
    el('button', { class: 'conta-menu__item', onClick: () => { fecharMenuConta(); trocarMeuPin(); } },
      [el('i', { class: 'ph ph-hash' }), el('span', { text: 'Trocar meu PIN' })]),
    el('button', { class: 'conta-menu__item', onClick: () => { fecharMenuConta(); trocarSenha(); } },
      [el('i', { class: 'ph ph-lock' }), el('span', { text: 'Trocar senha' })]),
    el('div', { class: 'conta-menu__sep' }),
    el('button', { class: 'conta-menu__item', onClick: () => { fecharMenuConta(); fazerLogout(); } },
      [el('i', { class: 'ph ph-sign-out' }), el('span', { text: 'Sair' })]),
  ]);
  function fecharMenuConta() { menuConta.style.display = 'none'; document.removeEventListener('click', aoForaConta); }
  function aoForaConta(e) { if (!conta.contains(e.target)) fecharMenuConta(); }
  const avatar = el('button', { class: 'avatar', text: inicial, title: 'Conta conectada', 'aria-haspopup': 'true' });
  const conta = el('div', { class: 'topbar__conta' }, [avatar, menuConta]);
  avatar.addEventListener('click', (e) => {
    e.stopPropagation(); fecharChipMenu();
    if (menuConta.style.display === 'none') { menuConta.style.display = ''; document.addEventListener('click', aoForaConta); }
    else fecharMenuConta();
  });

  function voltarAoLogin() {
    const pin = el('input', { type: 'password', inputmode: 'numeric', maxlength: '6', class: 'op-pin', placeholder: '••••' });
    const erroEl = el('div', { class: 'op-erro', style: 'display:none', text: 'PIN incorreto' });
    let verificando = false, timer = null;
    const errar = (precisaTrocar) => { erroEl.textContent = precisaTrocar ? 'Muitos erros. Peça ao gestor para redefinir seu PIN.' : 'PIN incorreto'; erroEl.style.display = ''; pin.classList.remove('op-pin--erro'); void pin.offsetWidth; pin.classList.add('op-pin--erro'); pin.value = ''; pin.focus(); };
    async function voltar() {
      const v = pin.value.trim();
      if (!v) { toast('Digite seu PIN.', 'erro'); return false; }
      const r = await verificarPin(sessao.usuario.id, v);
      if (!r.ok) { errar(r.precisaTrocar); return false; }
      await definirOperadorLogin(); atualizarOperador(); toast('De volta ao seu acesso.', 'sucesso'); return true;
    }
    const ref = abrirModal({
      titulo: 'Voltar a ser eu',
      corpo: [el('p', { class: 'view__sub', style: 'margin-top:0', text: 'Digite o seu PIN para voltar ao seu acesso.' }), el('div', { class: 'campo' }, [el('label', { text: 'Seu PIN' }), pin]), erroEl],
      acoes: [
        { rotulo: 'Cancelar', classe: 'btn' },
        { rotulo: 'Confirmar', classe: 'btn btn--primario', onClick: voltar },
      ],
    });
    pin.addEventListener('input', () => {
      const v = pin.value.trim();
      clearTimeout(timer); erroEl.style.display = 'none'; pin.classList.remove('op-pin--erro');
      if (v.length < 4 || verificando) return;
      timer = setTimeout(async () => {
        verificando = true;
        const r = await verificarPin(sessao.usuario.id, v);
        verificando = false;
        if (pin.value.trim() !== v) return;
        if (r.ok) { await definirOperadorLogin(); atualizarOperador(); toast('De volta ao seu acesso.', 'sucesso'); ref.fechar(); }
        else { errar(r.precisaTrocar); }
      }, 320);
    });
    requestAnimationFrame(() => pin.focus());
  }

  function trocarMeuPin() {
    const senha = el('input', { type: 'password', autocomplete: 'current-password', placeholder: 'Sua senha de login' });
    const novo = el('input', { type: 'password', inputmode: 'numeric', maxlength: '6', placeholder: 'Novo PIN (4 dígitos)' });
    const conf = el('input', { type: 'password', inputmode: 'numeric', maxlength: '6', placeholder: 'Confirmar novo PIN' });
    abrirModal({
      titulo: 'Trocar meu PIN',
      corpo: [
        el('p', { class: 'view__sub', style: 'margin-top:0', text: 'Confirme a SENHA DE LOGIN (a que você usa para entrar, e-mail/senha) — não é o PIN.' }),
        el('div', { class: 'campo' }, [el('label', { text: 'Senha de login' }), senha]),
        el('div', { class: 'campo' }, [el('label', { text: 'Novo PIN' }), novo]),
        el('div', { class: 'campo' }, [el('label', { text: 'Confirmar novo PIN' }), conf]),
      ],
      acoes: [
        { rotulo: 'Cancelar', classe: 'btn' },
        { rotulo: 'Salvar', classe: 'btn btn--primario', onClick: async () => {
          if (!senha.value) { toast('Informe a senha da conta.', 'erro'); return false; }
          if (!/^\d{4,6}$/.test(novo.value.trim())) { toast('O PIN deve ter de 4 a 6 dígitos.', 'erro'); return false; }
          if (novo.value.trim() !== conf.value.trim()) { toast('A confirmação não confere.', 'erro'); return false; }
          const { error } = await supabase.auth.signInWithPassword({ email, password: senha.value });
          if (error) { toast('Senha da conta incorreta.', 'erro'); return false; }
          const ok = await redefinirMeuPin(novo.value.trim());
          if (!ok) { toast('Não foi possível trocar o PIN.', 'erro'); return false; }
          toast('PIN alterado com sucesso.', 'sucesso');
          return true;
        } },
      ],
    });
  }

  function trocarSenha() {
    const atual = el('input', { type: 'password', autocomplete: 'current-password', placeholder: 'Senha atual' });
    const nova = el('input', { type: 'password', autocomplete: 'new-password', placeholder: 'Nova senha (mín. 6)' });
    const conf = el('input', { type: 'password', autocomplete: 'new-password', placeholder: 'Confirmar nova senha' });
    abrirModal({
      titulo: 'Trocar senha',
      corpo: [
        el('div', { class: 'campo' }, [el('label', { text: 'Senha atual' }), atual]),
        el('div', { class: 'campo' }, [el('label', { text: 'Nova senha' }), nova]),
        el('div', { class: 'campo' }, [el('label', { text: 'Confirmar nova senha' }), conf]),
      ],
      acoes: [
        { rotulo: 'Cancelar', classe: 'btn' },
        { rotulo: 'Salvar', classe: 'btn btn--primario', onClick: async () => {
          if (!atual.value) { toast('Informe a senha atual.', 'erro'); return false; }
          if ((nova.value || '').length < 6) { toast('A nova senha precisa de ao menos 6 caracteres.', 'erro'); return false; }
          if (nova.value !== conf.value) { toast('A confirmação não confere.', 'erro'); return false; }
          const { error: e1 } = await supabase.auth.signInWithPassword({ email, password: atual.value });
          if (e1) { toast('Senha atual incorreta.', 'erro'); return false; }
          const { error: e2 } = await supabase.auth.updateUser({ password: nova.value });
          if (e2) { toast('Não foi possível trocar: ' + e2.message, 'erro'); return false; }
          toast('Senha alterada com sucesso.', 'sucesso');
          return true;
        } },
      ],
    });
  }

  function atualizarOperador() {
    pintarChip(); montarNav();
    const r = rotaInicial();
    ir(r || '/movimentacao');
  }

  pintarChip();

  const avisoBloq = el('button', { class: 'topbar__aviso', style: 'display:none', onClick: abrirJanelaBloqueios }, [
    el('i', { class: 'ph ph-warning' }), el('span', { class: 'topbar__aviso-n', text: '0' }),
  ]);
  const avisoDev = el('button', { class: 'topbar__aviso topbar__aviso--dev', style: 'display:none', onClick: () => mostrarFeedbacksRecusa(atualizarAvisoDev) }, [
    el('i', { class: 'ph ph-chat-dots' }), el('span', { class: 'topbar__aviso-n', text: '0' }),
  ]);
  const avisoWrap = el('div', { class: 'topbar__aviso-wrap' }, [avisoDev, avisoBloq]);
  async function carregarBloqueados() {
    try {
      const { data, error } = await supabase.from('colaborador')
        .select('id, nome, suspensao_em, suspensao_ate').eq('acesso_suspenso', true).order('nome');
      return error ? [] : (data || []);
    } catch { return []; }
  }
  async function abrirJanelaBloqueios() {
    const linhas = await carregarBloqueados();
    const corpo = [el('p', { class: 'view__sub', style: 'margin-top:0', text: 'Colaboradores com acesso suspenso (afastados). Não estão autorizados a retirar chave e só é permitido o acesso como visitante.' })];
    if (!linhas.length) corpo.push(el('p', { class: 'view__sub', text: 'Nenhum no momento.' }));
    linhas.forEach((l) => {
      const inicio = l.suspensao_em ? new Date(l.suspensao_em).toLocaleDateString('pt-BR') : null;
      const ate = l.suspensao_ate ? 'até ' + new Date(l.suspensao_ate + 'T00:00:00').toLocaleDateString('pt-BR') : 'por tempo indeterminado';
      const sub = (inicio ? `desde ${inicio} · ` : '') + ate;
      corpo.push(el('div', { class: 'aviso-pop__item' }, [
        el('i', { class: 'ph ph-lock-key' }),
        el('div', {}, [el('div', { class: 'aviso-pop__nome', text: formatarNome(l.nome) }), el('div', { class: 'aviso-pop__sub', text: sub })]),
      ]));
    });
    abrirModal({ titulo: 'Acesso suspenso', corpo, acoes: [{ rotulo: 'Fechar', classe: 'btn btn--primario' }] });
  }
  const versao = el('span', { class: 'topbar__versao', title: 'Versão do sistema', text: `v${APP_VERSION}` });
  const topbar = el('header', { class: 'topbar topbar--limpo' }, [
    appLauncher(),
    el('div', { class: 'topbar__user', style: 'gap:16px' }, [avisoWrap, chipWrap, versao, conta]),
  ]);

  async function atualizarAvisoBloqueios() {
    const num = (await carregarBloqueados()).length;
    avisoBloq.style.display = num > 0 ? '' : 'none';
    avisoBloq.querySelector('.topbar__aviso-n').textContent = String(num);
    avisoBloq.title = num > 0 ? `${num} colaborador(es) com acesso suspenso` : '';
  }
  async function atualizarAvisoDev() {
    let num = 0;
    try { num = (await feedbacksDecisao(operadorAtual.id)).length; } catch (e) { num = 0; }
    avisoDev.style.display = num > 0 ? '' : 'none';
    avisoDev.querySelector('.topbar__aviso-n').textContent = String(num);
    avisoDev.title = num > 0 ? `Você tem ${num} devolutiva(s) — clique para ver` : '';
  }

  const main = el('div', { class: 'main' }, [topbar, el('div', { id: 'view', class: 'view' })]);
  app.append(el('div', { class: 'layout' }, [sidebar, main]));

  const fab = el('button', { class: 'fab-sug', title: 'Enviar uma sugestão', 'aria-label': 'Enviar sugestão', onClick: abrirSugestao }, [el('i', { class: 'ph ph-chat-dots' })]);
  app.append(fab);
  if (podeAcessar('chaves')) {
    const fabChave = el('button', { class: 'fab-sug fab-chave', title: 'Sugerir nova chave', 'aria-label': 'Sugerir nova chave', onClick: abrirSugerirNovaChave }, [el('i', { class: 'ph ph-key' })]);
    app.append(fabChave);
  }
  function abrirSugestao() {
    const texto = el('textarea', { rows: '6', placeholder: 'Escreva sua sugestão ou o que poderia melhorar…' });
    abrirModal({
      titulo: 'Enviar sugestão',
      corpo: [
        el('p', { class: 'view__sub', style: 'margin-top:0', text: 'Sua ideia vai para o gestor avaliar. Obrigado por ajudar a melhorar o sistema!' }),
        el('div', { class: 'campo' }, [el('label', { text: 'Sugestão' }), limpavel(texto)]),
      ],
      acoes: [
        { rotulo: 'Cancelar', classe: 'btn' },
        { rotulo: 'Enviar', classe: 'btn btn--primario', onClick: async () => {
          if (!texto.value.trim()) { toast('Escreva sua sugestão.', 'erro'); return false; }
          const { erro } = await criarSugestaoSistema(texto.value);
          if (erro) { toast('Não foi possível enviar: ' + erro, 'erro'); return false; }
          toast('Sugestão enviada. Obrigado!', 'sucesso');
          return true;
        } },
      ],
    });
  }

  function setAviso(caminho, n, titulo) {
    const link = navBox.querySelector(`.navlink[data-caminho="${caminho}"]`);
    if (!link) return;
    let b = link.querySelector('.navlink__aviso');
    if (n > 0) {
      if (!b) { b = el('span', { class: 'navlink__aviso' }); link.append(b); }
      b.textContent = String(n);
      b.title = titulo(n);
    } else if (b) { b.remove(); }
  }
  async function atualizarAvisos() {
    if (podeAcessar('cad_colaboradores')) {
      try { const { data, error } = await supabase.rpc('avulsos_pendentes'); setAviso('/colaboradores', error ? 0 : (data || []).length, (n) => `${n} para cadastrar`); } catch { /* ignore */ }
    }
    if (podeAcessar('cad_chaves')) setAviso('/chaves', await contarSugestoesPendentes(), (n) => `${n} sugestão(ões) de chave`);
    if (podeAcessar('cad_setores')) setAviso('/setores', await contarSugestoesSetor(), (n) => `${n} sugestão(ões) de setor`);
    if (podeAcessar('cad_visita_motivo')) { try { setAviso('/visita-motivos', await contarMotivosPendentes(), (n) => `${n} motivo(s) aguardando aprovação`); } catch { /* ignore */ } }
    if (podeAcessar('cad_visita_empresa')) { try { setAviso('/visita-empresas', await contarEmpresasPendentes(), (n) => `${n} empresa(s) aguardando aprovação`); } catch { /* ignore */ } }
  }
  function agendarAvisos() { clearTimeout(avisosDeb); avisosDeb = setTimeout(() => { atualizarAvisos(); atualizarAvisoDev(); }, 400); }

  montado = true;
  montarNav();
  atualizarAvisoBloqueios();
  atualizarAvisoDev();
  // Avisos do menu ao vivo (nao dependem de navegar/recarregar): realtime + poll de seguranca + recount ao navegar.
  try {
    avisosCanal = supabase.channel('rt-avisos-menu')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'chave_sugestao' }, agendarAvisos)
      .on('postgres_changes', { event: '*', schema: 'public', table: 'setor_sugestao' }, agendarAvisos)
      .on('postgres_changes', { event: '*', schema: 'public', table: 'movimentacao_chaves' }, agendarAvisos)
      .on('postgres_changes', { event: '*', schema: 'public', table: 'colaborador' }, agendarAvisos)
      .on('postgres_changes', { event: '*', schema: 'public', table: 'visita_motivo' }, agendarAvisos)
      .on('postgres_changes', { event: '*', schema: 'public', table: 'visita_empresa' }, agendarAvisos)
      .on('postgres_changes', { event: '*', schema: 'public', table: 'avulso_baixa' }, agendarAvisos)
      .subscribe();
  } catch { /* ignore */ }
  avisosTimer = setInterval(() => { if (!document.hidden) { atualizarAvisos(); atualizarAvisoDev(); } }, 30000);
  onNavegar((c) => { limparAssinaturas(); marcarAtivo(c); atualizarAvisoBloqueios(); atualizarAvisos(); atualizarAvisoDev(); });
}

export function desmontarLayout() {
  montado = false;
  if (avisosCanal) { try { supabase.removeChannel(avisosCanal); } catch { /* ignore */ } avisosCanal = null; }
  if (avisosTimer) { clearInterval(avisosTimer); avisosTimer = null; }
}

function marcarAtivo(caminho) {
  document.querySelectorAll('.navlink[data-caminho]').forEach((n) => {
    n.classList.toggle('navlink--ativo', n.dataset.caminho === caminho);
  });
}



